// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"7aba5180","965":"123e2209"}[chunkId] + ".css";
};